import { render, staticRenderFns } from "./deliveryEvaluationInfo.vue?vue&type=template&id=22bfe7f7&scoped=true"
import script from "./deliveryEvaluationInfo.vue?vue&type=script&lang=js"
export * from "./deliveryEvaluationInfo.vue?vue&type=script&lang=js"
import style0 from "./deliveryEvaluationInfo.vue?vue&type=style&index=0&id=22bfe7f7&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bfe7f7",
  null
  
)

export default component.exports